import React from "react";
import { Container, Row, Col, Card, Accordion } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./ServicesPage.css";
import { useLanguage } from '../context/LanguageContext';

const ServicesPage = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const services = [
    {
      title: "HOME CARE SERVICE",
      title_ml: "ഹോം കെയർ സേവനം",
      subtitle: "We offer the following home care services",
      subtitle_ml: "ഹോം കെയർ സേവനങ്ങൾ",
      description:
        "Our affiliated palliative care units deliver vital medical and nursing services directly to patient`s homes, ensuring comfort and dignity. In collaboration with neighbours and the local community, we also provide psychological and social support for both patients and their families, fostering a caring and connected environment.We offer the following home care services",
        description_ml:
        "ഞങ്ങളുടെ അനുബന്ധ പാലിയേറ്റീവ് കെയർ യൂണിറ്റുകൾ രോഗികളുടെ വീടുകളിലേക്ക് നേരിട്ട് പ്രധാനമായ മെഡിക്കൽ, നഴ്സിംഗ് സേവനങ്ങൾ എത്തിക്കുന്നു, ആശ്വാസവും മാന്യമായ പരിചരണവും ഉറപ്പാക്കുന്നു. അയൽവാസികളും പ്രാദേശിക സമൂഹവും സഹകരിച്ച്, രോഗികൾക്കും അവരുടെ കുടുംബങ്ങൾക്കും മാനസികവും സാമൂഹികവുമായ പിന്തുണ നൽകുന്നു, കരുണയുള്ളതും ബന്ധമുള്ളതുമായ അന്തരീക്ഷം വളർത്തുന്നു. ഞങ്ങൾ താഴെ പറയുന്ന ഹോം കെയർ സേവനങ്ങൾ നൽകുന്നു.",
      image: "images/homecare-img.jpg",
      features: [
        "Doctor's home care (DHC)",
        "Nurse's home care (NHC)",
        "Volunteer home care (VHC)",
        "Physiotherapy home care",
        "Psychiatry home care",
      ],
      icon: "🏠",
    },
    {
      title: "REHABILITATION",
      title_ml: "പുനരധിവാസം",
      subtitle: "Our programme includes:",
      subtitle_ml: "ഞങ്ങളുടെ പ്രോഗ്രാമം ഉൾക്കൊള്ളുന്നത്:",
      description:
        "Dedicated day-care and rehabilitation programs are actively supporting individuals requiring palliative care, while also focusing on preventive Palliative Care. These initiatives provide comprehensive medical, emotional, and social support, including day-care services, as well as rehabilitation to enhance patients' independence and quality of life. Through these efforts, we aim to deliver compassionate care and promote long-term well-being for those with serious illnesses.",
      description_ml:
        "പാലിയേറ്റീവ് പരിചരണം ആവശ്യമുള്ള വ്യക്തികൾക്കായി പ്രത്യേക ഡേ-കെയർ, പുനരധിവാസ (rehabilitation) പരിപാടികൾ സജീവമായി പ്രവർത്തിച്ചുവരുന്നു. അതോടൊപ്പം തടസ്സരോധ പാലിയേറ്റീവ് പരിചരണത്തിനും (preventive palliative care) ഇത് മുൻഗണന നൽകുന്നു. രോഗികളുടെ ആത്മവിശ്വാസവും ജീവിതനിലവാരവും മെച്ചപ്പെടുത്തുന്നതിനായി ഡേ-കെയർ സേവനങ്ങളും പുനരധിവാസവും ഉൾപ്പെടെ സമഗ്രമായ വൈദ്യശാസ്ത്ര, വൈകാരിക, സാമൂഹിക പിന്തുണ ഇത്തരം സംരംഭങ്ങൾ ഉറപ്പാക്കുന്നു. ഈ പരിശ്രമങ്ങളിലൂടെ, ഗുരുതരമായ രോഗങ്ങളാൽ വിഷമിക്കുന്നവർക്ക് കരുണാർദ്രമായ പരിചരണം നൽകാനും അവരുടെ ദീർഘകാല ക്ഷേമം ഉറപ്പാക്കാനും ഞങ്ങൾ ലക്ഷ്യമിടുന്നു.",
      image: "images/daycare-img.jpg",
      features: [
        "Day care for paraplegic and differently abled",
        "Psychiatry day care",
        "Vocational rehabilitation",
      ],
      icon: "♿",
    },
    {
      title: "COMMUNITY VOLUNTEER NETWORK",
      title_ml: "സമൂഹ സന്നദ്ധ സേവന ശൃംഖല",
      subtitle: "We offer",
      subtitle_ml: "ഞങ്ങളുടെ സേവനങ്ങൾ",
      description:
        "We strive to provide each patient with personalized volunteer support from their local community. Community volunteers play a crucial role in connecting palliative care units with patients and their families.By utilizing their free time without expecting any reward, these community volunteers address the daily needs of patients and their families, serving as true advocates of the patients and their family.",
      description_ml:
        "ഓരോ രോഗിക്കും അവരുടെ പ്രദേശത്തുനിന്നുതന്നെയുള്ള സന്നദ്ധപ്രവർത്തകരുടെ സേവനം വ്യക്തിഗതമായി ലഭ്യമാക്കാൻ ഞങ്ങൾ പരമാവധി ശ്രമിക്കുന്നു. പാലിയേറ്റീവ് കെയർ യൂണിറ്റുകളെ രോഗികളുമായും അവരുടെ കുടുംബങ്ങളുമായും ബന്ധിപ്പിക്കുന്നതിൽ പ്രാദേശിക സന്നദ്ധപ്രവർത്തകർ നിർണായകമായ പങ്കാണ് വഹിക്കുന്നത്. പ്രതിഫലമൊന്നും പ്രതീക്ഷിക്കാതെ തങ്ങളുടെ ഒഴിവുസമയം വിനിയോഗിച്ചുകൊണ്ട്, ഈ സന്നദ്ധപ്രവർത്തകർ രോഗികളുടെയും അവരുടെ കുടുംബങ്ങളുടെയും ദൈനംദിന ആവശ്യങ്ങൾ കണ്ടറിഞ്ഞ് സഹായിക്കുകയും അവരുടെ യഥാർത്ഥ സംരക്ഷകരായി പ്രവർത്തിക്കുകയും ചെയ്യുന്നു.",
      image: "images/volunteer-img.jpg",
      features: [
        "Provide personalised volunteer support from local communities",
        "Friendly visit and listening the patients",
        "Facilitate access to government and non-government services",
        "Assist with social security schemes for patients",
        "Transportation assistance",
        "Address daily needs of patients and their families",
      ],
      icon: "🤝",
    },
    {
      title: "PALLIATIVE CARE EQUIPMENTS",
      title_ml: "പാലിയേറ്റീവ് കെയർ ഉപകരണങ്ങൾ",
      subtitle: "Some  Assistive Devices for Daily Living",
      subtitle_ml: "ദിവസകലഹ് ഉപകരണങ്ങൾ",
      description:
        "Palliative care equipment is designed to improve the quality of life for patients with serious illnesses, particularly those who are bedridden or homebound. These tools support daily activities and medical needs, offering comfort and independence. However, high costs and limited availability can make them inaccessible for many. Palliative care units and community initiatives bridge this gap by providing the following equipment to patients' homes:",
      description_ml:
        "ഗുരുതരമായ രോഗങ്ങളാൽ വിഷമിക്കുന്ന, പ്രത്യേകിച്ച് കിടപ്പിലായതോ വീടുകളിൽത്തന്നെ കഴിയുന്നതോ ആയ രോഗികളുടെ ജീവിതനിലവാരം മെച്ചപ്പെടുത്തുന്നതിനാണ് പാലിയേറ്റീവ് കെയർ ഉപകരണങ്ങൾ രൂപകൽപ്പന ചെയ്തിരിക്കുന്നത്. ദൈനംദിന കാര്യങ്ങൾക്കും വൈദ്യശാസ്ത്രപരമായ ആവശ്യങ്ങൾക്കും പിന്തുണ നൽകുന്ന ഈ ഉപകരണങ്ങൾ രോഗികൾക്ക് ആശ്വാസവും സ്വയംപര്യാപ്തതയും നൽകുന്നു. എന്നിരുന്നാലും, ഉയർന്ന വിലയും ലഭ്യതാക്കുറവും കാരണം ഇവ പലർക്കും പ്രാപ്യമല്ലാതാകാറുണ്ട്. പാലിയേറ്റീവ് കെയർ യൂണിറ്റുകളും ജനകീയ കൂട്ടായ്മകളും താഴെ പറയുന്ന ഉപകരണങ്ങൾ രോഗികളുടെ വീടുകളിൽ എത്തിച്ചുനൽകിക്കൊണ്ട് ഈ പരിമിതി പരിഹരിക്കുന്നു.",
      image: "images/equipment-img.jpg",
      features: [
        "Hospital beds (adjustable for comfort and positioning)",
        "Wheelchairs and mobility aids (for enhanced movement)",
        "Commodes and bath chairs (for hygiene and convenience)",
        "Pressure-relieving mattresses (to prevent bedsores)",
        "Oxygen concentrators (for respiratory support)",
        "Nebulizers (for administering medication)",
        "Suction devices (to clear airways)",
        "Pulse oximeter (for monitoring oxygen levels)",
        "BiPAP Machine (device to help breathing difficulties)",
      ],
      icon: "🛏️",
    },
    {
      title: "COMMUNITY PSYCHIATRY PROGRAMME",
      title_ml: "സമൂഹ മാനസികാരോഗ്യ പരിപാടി",
      subtitle: "Our psychiatry services",
      subtitle_ml: "ഞങ്ങളുടെ മാനസികാരോഗ്യ സേവനങ്ങൾ",
      description:
        "The primary goal of the community-based mental health care program is the continuous care of isolated and untreated mentally ill individuals with the support of local community. It provides various type of care and medications through community volunteers:",
      description_ml:
        "പ്രാദേശിക സമൂഹത്തിന്റെ പിന്തുണയോടെ, ഒറ്റപ്പെട്ടുപോയതും ചികിത്സ ലഭിക്കാത്തതുമായ മാനസിക വെല്ലുവിളികൾ നേരിടുന്ന വ്യക്തികൾക്ക് തുടർച്ചയായ പരിചരണം ഉറപ്പാക്കുക എന്നതാണ് ജനകീയ മാനസികാരോഗ്യ പരിചരണ പരിപാടിയുടെ (community-based mental health care program) പ്രധാന ലക്ഷ്യം. സന്നദ്ധപ്രവർത്തകർ വഴി വിവിധ തരത്തിലുള്ള പരിചരണങ്ങളും മരുന്നുകളും ഈ പദ്ധതിയിലൂടെ ലഭ്യമാക്കുന്നു.",
      image: "images/mentalhealth-img.jpg",
      features: [
        "Social Work Assistance",
        "Medication Access",
        "Day care Services",
        "Home Care",
        "Rehabilitation Programs",
      ],
      icon: "🧠",
    },
    {
      title: "COMMUNITY AWARENESS AND VOLUNTEER MOBILISATION",
      title_ml: "സമൂഹ ബോധവൽക്കരണം & സന്നദ്ധ സേവന ശൃംഖല",
      subtitle: "Community Health awareness",
      subtitle_ml: "സമൂഹ ആരോഗ്യ ബോധവൽക്കരണം",
      description:
        " Community-based Palliative care is Social health initiative under collective ownership. As a social security system, to achieve its goals, the initiative implements a variety of programs aimed at raising awareness and encouraging active participation. These may include:",
      description_ml:
        "കമ്മ്യൂണിറ്റി അധിഷ്ഠിത പല്ലിയേറ്റീവ് പരിചരണം, കൂട്ടായ ഉടമസ്ഥതയിലുള്ള ഒരു സാമൂഹിക ആരോഗ്യ സംരംഭമാണ്. ഒരു സാമൂഹിക സുരക്ഷാ സംവിധാനം എന്ന നിലയിൽ, അതിന്റെ ലക്ഷ്യങ്ങൾ കൈവരിക്കുന്നതിനായി, ഈ സംരംഭം അവബോധം വളർത്തുന്നതിനും സജീവമായ പങ്കാളിത്തം പ്രോത്സാഹിപ്പിക്കുന്നതിനുമായി വിവിധ പരിപാടികൾ നടപ്പിലാക്കുന്നു. അവയിൽ ഇവ ഉൾപ്പെട്ടേക്കാം:",
      image: "images/community-img.jpg",
      features: [
        "Educational Campaigns: Workshops, seminars, and community dialogues to inform people about palliative care",
        "Volunteer Training: Programs to equip community members with skills to provide basic care, emotional support, or logistical assistance",
        "Support Groups: Facilitating peer-led groups for patients, caregivers, and families to share experiences",
        "Outreach Initiatives: Sub units, door-to-door visits, local events, or media campaigns to engage underserved populations",
        "Collaborative Partnerships: Working with schools, institutions, and local bodies to integrate palliative care awareness",
      ],
      icon: "📢",
    },
  ];

  const cardVariants = {
    offscreen: {
      y: 50,
      opacity: 0,
    },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8,
      },
    },
  };

  return (
    <>
      <div className="services-page-wrapper">
        {/* Hero Section */}
        <section className="services-hero">
          <div className="hero-overlay">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8 }}
              className="hero-content"
            >
              <h1 className="text-danger bg-in">
                {language === "en" ? "Our Services" : "ഞങ്ങളുടെ സേവനങ്ങൾ"}
              </h1>
            </motion.div>
          </div>
        </section>

        {/* Services Grid */}
        <Container className="services-container py-5">
          <Row className="g-4 justify-content-center">
            {services.map((service, index) => (
              <Col key={index} xs={12} md={6} lg={4}>
                <motion.div
                  initial="offscreen"
                  whileInView="onscreen"
                  viewport={{ once: true, amount: 0.2 }}
                  variants={cardVariants}
                >
                  <Card className="service-card shadow-sm" style={{ height: '100vh' }}>
                    <div className="card-image-container">
                      <Card.Img
                        variant="top"
                        src={service.image}
                        alt={service.title}
                        className="card-image"
                      />
                      <div className="service-icon">{service.icon}</div>
                    </div>
                    <Card.Body>
                      <Card.Title className="text-danger">
                        {language === "en" ? service.title : service.title_ml}
                      </Card.Title>
                      <Card.Text>
                        {language === "en" ? service.description : service.description_ml}
                      </Card.Text>

                      <div className="features-list">
                        <Accordion defaultActiveKey="0">
                          <Accordion.Item eventKey="1">
                            <Accordion.Header>
                              <h6 className="text-primary fw-bold">{service.subtitle}</h6>
                            </Accordion.Header>
                            <Accordion.Body>
                              <ul>
                                {service.features.map((feature, i) => (
                                  <li key={i} className="text-secondary">
                                    {feature}
                                  </li>
                                ))}
                              </ul>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </div>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default ServicesPage;
